import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export class Frame {

  isCallable () {
    return true
  }
  init () {
    this.frameEffect()
  }

  frameEffect () {

    const elements = document.querySelectorAll('.c-frame')

    elements.forEach( (element, index) => {

      const frameTimeline = gsap.timeline()

      const bottomLeft = element.querySelector('.c-frame--bottom-left')
      const bottomRight = element.querySelector('.c-frame--bottom-right')
      const topLeft = element.querySelector('.c-frame--top-left')
      const topRight = element.querySelector('.c-frame--top-right')

      const divs = element.querySelectorAll(':scope > div')

      frameTimeline.to(topLeft, {
        duration: 1,
        left: '82px',
        opacity: 1,
        ease: 'power2.out',
        delay: 0.4
      }, 'start').to(topLeft, {
        duration: 1,
        top: '25px',
        ease: 'power2.out',
      }, 'start+=1.2')

      frameTimeline.to(topRight, {
        duration: 1,
        right: '82px',
        alpha: 1,
        ease: 'power2.out',
        delay: 0.4
      }, 'start').to(topRight, {
        duration: 1,
        top: '25px',
        ease: 'power2.out',
      }, 'start+=1.2')

      frameTimeline.to(bottomLeft, {
        duration: 1,
        left: '82px',
        alpha: 1,
        ease: 'power2.out',
        delay: 0.4
      }, 'start').to(bottomLeft, {
        duration: 1,
        bottom: '24px',
        ease: 'power2.out',
      }, 'start+=1.2')

      frameTimeline.to(bottomRight, {
        duration: 1,
        right: '82px',
        alpha: 1,
        ease: 'power2.out',
        delay: 0.4
      }, 'start').to(bottomRight, {
        duration: 1,
        bottom: '24px',
        ease: 'power2.out',
      }, 'start+=1.2')

      divs.forEach(div => {
        gsap.to(div, {
          duration: 1,
          opacity: gsap.utils.random(0.2, 0.8),
          delay: 0.8,
          repeat: -1,
          yoyo: true,
          ease: 'power1.out',
        }, 'start')
      })

    });

  };

}
